<script>
  import urlBuilder from "@sanity/image-url";
  import { sanityConfiguration } from "../sanityClient";

  export let ref;

  const urlFor = (source) =>
    urlBuilder({
      projectId: sanityConfiguration.projectId,
      dataset: sanityConfiguration.dataset,
    }).image(source);
</script>

<div class="image-wrapper">
  <img src={urlFor(ref).width(900)} alt="" style="width: 100%;" />
</div>

<style>
  .image-wrapper {
    width: 100%;
    margin-bottom: 24px;
  }
</style>
